module.exports = __webpack_public_path__ + "img/pirouetti.b8278e8d.png";